import { Injectable } from "@angular/core";
import { BaseService } from "@dmms/core/http";
import { Observable, map } from "rxjs";
import { environment } from "src/environments/environment";
import { FileStorageEndpoints } from "../types/file-storage-endpoints";
import { IApiResponse } from "@models/http/http-options";

@Injectable({
  providedIn: "root",
})
export class FileStorageApiService extends BaseService {
  uploadPhoto(file: File, version = 1): Observable<string> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http
      .post<
        IApiResponse<string> | string
      >(`${environment.apiUrl}v${version}/${FileStorageEndpoints.FileStorage}`, formData)
      .pipe(
        map((response) =>
          typeof response === "string" ? response : response?.value || "",
        ),
      );
  }

  uploadVideo(file: File, version = 1): Observable<string> {
    const formData = new FormData();
    formData.append("file", file);

    return this.http
      .post<
        IApiResponse<string> | string
      >(`${environment.apiUrl}v${version}/${FileStorageEndpoints.FileStorage}`, formData)
      .pipe(
        map((response) =>
          typeof response === "string" ? response : response?.value || "",
        ),
      );
  }

  /**
   * Получить файл (blob) из файлового хранилища
   */
  getPhoto(photoPath: string, version = 1): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}v${version}/${FileStorageEndpoints.FileStorage}/${photoPath}`,
      { responseType: "blob" },
    );
  }

  deletePhoto(photoPath: string, version = 1): Observable<void> {
    return this.remove(
      `v${version}/${FileStorageEndpoints.FileStorage}/${photoPath}`,
    );
  }

  /**
   * Получить файл (blob) по пути
   */
  getFile(path: string, version = 1): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}v${version}/${FileStorageEndpoints.FileStorage}/${path}`,
      { responseType: "blob" },
    );
  }
}
